module.exports = __webpack_public_path__ + "img/stick_restauration_restaurant.105144d5.svg";